// src/hooks/useHeartbeat.js
import { useEffect } from 'react';
import api from '../api/axios';

export default function useHeartbeat(gateToken) {
  useEffect(() => {
    if (!gateToken) return;

    const send = () => {
      api.post('/gate/heartbeat', null, {
        params: { token: gateToken },
      }).catch(() => {});
    };

    send();
    const id = setInterval(send, 5000);

    return () => clearInterval(id);
  }, [gateToken]);
}
